import { IntlShape } from 'react-intl';

export const boldenText = (chunks: React.ReactNode[]) => (
  <span>
    <strong>{chunks}</strong>
  </span>
);

export const getTranslation = (
  intl: IntlShape,
  id: string,
  values?: Record<string, string | number | Date>
) => intl.formatMessage({ id }, values);
